module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queryResult"
  }, [_c('head-menu', [_c('a', {
    staticClass: "editQuery",
    attrs: {
      "href": '#/edit/' + _vm.$route.params.id
    }
  }, [_vm._v("Edit Query")])]), _vm._v(" "), _c('div', {
    staticClass: "queryContainer"
  }, [_c('h3', [_vm._v(_vm._s(_vm.reportName))]), _vm._v(" "), _c('div', {
    staticClass: "reportQuery"
  }, [_vm._v("\n      " + _vm._s(_vm.reportQuery) + "\n    ")]), _vm._v(" "), (_vm.list) ? _c('div', [_c('div', {
    on: {
      "mouseleave": _vm.mouseLeave
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "stripe": ""
    },
    on: {
      "cell-mouse-enter": _vm.cellMouseEnter,
      "cell-click": _vm.cellMouseClick
    }
  }, _vm._l((_vm.columns), function(col) {
    return _c('el-table-column', {
      attrs: {
        "prop": col,
        "label": col
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalPages
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "moreDetail"
  }, [_c('h4', [_vm._v(_vm._s(_vm.moreDetailHeader))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.moreDetailBody))])])]) : _c('div', {
    staticClass: "tabl"
  }, [(_vm.error) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _c('div', [_vm._v("loading")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa7d02c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueryResult.vue
// module id = 226
// module chunks = 1